import { listPresetDefinitions } from '@next-adapter/preset-registry.js'

export function listAvailablePresets() {
  return listPresetDefinitions()
}
